<template>
  <div class="all-content-container">
    <portal to="play-filter">
      <div  class="filter-header">
        <div class="filter">
          <button type="button" @click="changeFilterToggle()">{{ filterText }}</button>
        </div>
      </div>
    </portal>
    <InfiniteScrollSeriesCellList
      v-if="cellList && cellList.length"
      :content-info="contentInfo"
      :key="'infinite-scroll-bottom-vod' + $route.fullPath"
      :cell-list="cellList"
      :thumbnail-info="thumbnailInfo"
      section="vod"
      @load-more="loadMore"
    />
  </div>
</template>
<script>
import InfiniteScrollSeriesCellList from '@/components/section/template/cell/InfiniteScrollSeriesCellList'
import { getBandTypeInfoByCellType } from '@/common/image.util'
import { get, filter as _filter } from 'lodash'
import { SORT_BY_NEWER } from '@/common/constant'
import VueSticky from 'vue-sticky'
import { mapMutations } from 'vuex'
import { BottomTabService } from '@/common/api/api.service'
import { parse, parseUrl } from 'query-string'

export default {
  name: 'EpisodeContentList',
  components: {
    InfiniteScrollSeriesCellList
  },
  props: {
    contentInfo: {
      type: Object,
      default: () => {}
    },
    landingInfo: {
      type: Object,
      default: () => {}
    },
    section: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isEmptyList: true,
      endOfList: false,
      offset: 0,
      limit: 20,
      cellList: [],
      thumbnailInfo: {},
      orderFilter: SORT_BY_NEWER,
      filterTitleMap: {},
      filterObject: {},
      genre: 'all',
      programId: get(this.contentInfo, 'programid', ''),
      contentId: '',
      orgOrderFilter: SORT_BY_NEWER,
      isOrderFilterNew: true
    }
  },
  directives: {
    VueSticky
  },
  computed: {
    getCellListContainerClassName () {
      return `cell-list responsive cell-${this.thumbnailInfo.type} ${this.section}`
    },
    filterText () {
      return this.isOrderFilterNew ? '최신순' : '오래된순'
    }
  },
  methods: {
    ...mapMutations(['showLoadingProgress', 'hideLoadingProgress']),
    setFilterQuery ({ queryString, selectedTitle, filterIndex }) {
      this.cellList = []
      this.offset = 0
      this.endOfList = false
      this.filterTitleMap[filterIndex] = selectedTitle
      this.genre = get(parse(queryString), 'genre', 'all')
      this.setData()
    },
    changeFilterToggle () {
      this.isOrderFilterNew = !this.isOrderFilterNew
      this.orderFilter = this.isOrderFilterNew ? 'new' : 'old'
      this.offset = 0
      this.cellList = []
      this.setData()
    },
    loadMore () {
      if (this.endOfList) return
      this.setData()
    },
    getInitOrderFilter () {
      const tabs = get(this.landingInfo, 'landing_list.tab', [])
      const [ episodeTab ] = tabs.filter(tab => tab.type === 'episode')
      const filter = get(parseUrl(get(episodeTab, 'path', '')), 'query.orderby', '')

      this.isOrderFilterNew = (filter === 'new')
      return filter
    },
    setData () {
      this.showLoadingProgress()

      const tabEpisode = _filter(get(this.landingInfo, 'landing_list.tab', []), { type: 'episode' })
      let path = ''
      if (tabEpisode && tabEpisode.length > 0) {
        path = get(tabEpisode[0], 'path')
      }

      const callApiFunction = BottomTabService.getContentAllApi(this.section)
      // FIXME: 일단 래거시 call api function 사용 -> 추후 변경 예정 22/11/16 (e.g RelatedContentList)
      if (typeof callApiFunction === 'function') {
        callApiFunction(
          { contentID: this.contentInfo.contentid,
            programID: this.programId,
            movieID: this.contentInfo.movieid,
            channelID: this.contentInfo.channelid,
            offset: this.offset,
            limit: this.limit,
            orderBy: this.orderFilter,
            genre: this.genre,
            path: path
          }).then(({ data }) => {
          this.hideLoadingProgress()
          if (this.offset === 0) {
            this.filterObject = get(data, 'filter', {})
            this.thumbnailInfo = getBandTypeInfoByCellType(get(data, ['cell_toplist', 'cell_type'], ''))
          }
          let resultList = get(data, ['cell_toplist', 'celllist'], [])
          this.endOfList = resultList.length === 0
          this.isEmptyList = resultList.length === 0
          if (this.endOfList || this.isEmptyList) return
          this.offset += this.limit
          this.cellList = this.cellList.concat(resultList)
          if (this.section === 'live') {
            this.endOfList = true
          }
        })
      }
    },
    reload () {
      this.offset = 0
      this.cellList = []
      location.reload()
    }
  },
  created () {
    this.orderFilter = this.getInitOrderFilter()
    this.orgOrderFilter = get(this.contentInfo, 'episodeorder', 'new')
    this.setData()
  }
}
</script>
<style scoped>
.filter-header {
  width: 100%;
  /*height: 60px;*/
  padding: 10px 10px 0 10px;
  z-index: 600;
  box-sizing: border-box;
  text-align: right;
  font-size: 0;
}
.filter-header:after{
  display: block;
  clear: both;
  content: '';
}
.filter-header span {
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  line-height: 20px;
}
.filter-header.refresh span{
  margin-right: 0;
}
.filter-header-wrapper {
  width: 100%;
  background-color: #f7f7f7;
  height: 60px;
}
.filter-header .old-new + .old-new{
  margin-left: 16px;
}
.filter-header .old-new {
  position: relative;
  float: left;
  padding: 8px 0;
  color: #a5a5a5;
  outline: none;
}
.filter-header .old-new:first-child:after{
  position: absolute;
  content: '';
  top: 13px;
  right: -8px;
  width: 1px;
  height: 10px;
  background-color: #a5a5a5;
}
.filter-header .old-new.on {
  color: #fff;
}
.filter-area{
  float: left;
  line-height: 20px;
  padding: 8px 0;
}
</style>
